export const SUPPORTED_LANGS = ['bg', 'en'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

const COOKIE_NAME = 'lang';
const COOKIE_MAX_AGE_DAYS = 365;

export function isLang(value: unknown): value is Lang {
  return (
    typeof value === 'string' &&
    (SUPPORTED_LANGS as readonly string[]).includes(value)
  );
}

export function readLangCookie(): Lang | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)lang=([^;]+)/);
  if (!match) return null;
  const value = decodeURIComponent(match[1]);
  return isLang(value) ? value : null;
}

export function writeLangCookie(lang: Lang): void {
  if (typeof document === 'undefined') return;
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const isHttps =
    typeof window !== 'undefined' && window.location.protocol === 'https:';
  const secure = isHttps ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${lang}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}

export function detectBrowserLang(navLang: string | undefined | null): Lang {
  if (!navLang) return 'bg';
  const lower = navLang.toLowerCase();
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('bg')) return 'bg';
  return 'bg';
}

export function resolveInitialLang(navLang: string | undefined | null): Lang {
  return readLangCookie() ?? detectBrowserLang(navLang);
}
